/** Links and copy shared by the MCP pages (#939). */

export const MCP_SLACK_URL = "https://cox.enterprise.slack.com/archives/C08T4DUNCQH";
export const MCP_SLACK_LABEL = "#ai-mcp";
export const MCP_REQUEST_URL =
  "https://ghe.coxautoinc.com/Delivery-Platform/product-management/discussions/new?category=onboard-mcp-proxy";
export const MCP_BUG_URL =
  "https://ghe.coxautoinc.com/Delivery-Platform/product-management/discussions/new?category=bug";
export const MCP_ONBOARDING_URL =
  "https://ghe.coxautoinc.com/Delivery-Platform/mcp-platform/blob/main/docs/onboarding.md";

/** "Added" dates: day precision, in the viewer's locale. Empty when the registry gave none. */
export function formatAddedDate(iso: string): string {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

/** The name people search for in Claude's Connectors list, e.g. "Rally MCP Server" → "Rally". */
export function connectorName(title: string): string {
  return title.replace(/\s+MCP( Server)?$/i, "").trim() || title;
}
